module.exports = __webpack_public_path__ + "static/media/5.57f9c71a.png";